export function navigation() {
	const mobileNavigation = document.getElementById("mobileNavigation");

	if (!mobileNavigation) return;

	let navigationOpen = false;
	const mobileNavigationTrigger = document.getElementById(
		"mobileNavigationTrigger"
	);
	const svgGroups = mobileNavigationTrigger.querySelectorAll("g");

	const switchSvgGroups = () => {
		svgGroups.forEach((g) => {
			if (g.classList.contains("opacity-0")) {
				g.classList.remove("opacity-0");
				g.classList.add("opacity-100");
			} else {
				g.classList.remove("opacity-100");
				g.classList.add("opacity-0");
			}
		});
	};

	const onOpen = () => {
		mobileNavigation.classList.remove("hidden");
		mobileNavigation.classList.add("grid");
		switchSvgGroups();
		setTimeout(() => {
			mobileNavigation.children[0].classList.add(
				"translate-y-0",
				"opacity-100"
			);
			mobileNavigation.children[0].classList.remove(
				"-translate-y-full",
				"opacity-0"
			);
		}, 25);
	};

	const onClose = () => {
		mobileNavigation.children[0].classList.remove(
			"translate-y-0",
			"opacity-100"
		);
		mobileNavigation.children[0].classList.add(
			"-translate-y-full",
			"opacity-0"
		);
		switchSvgGroups();
		setTimeout(() => {
			mobileNavigation.classList.remove("grid");
			mobileNavigation.classList.add("hidden");
		}, 500);
	};

	const always = () => {
		navigationOpen = !navigationOpen;
		document.body.classList.toggle("overflow-hidden");
	};

	mobileNavigationTrigger.addEventListener("click", () => {
		always();
		return navigationOpen ? onOpen() : onClose();
	});
}
